import { createFileRoute } from '@tanstack/react-router';
import { CompanyReadinessView } from '@/features/CompanyReadiness/CompanyReadinessView';

export const Route = createFileRoute('/org/company-readiness')({
  component: CompanyReadinessPage,
});

function CompanyReadinessPage() {
  return (
    <div className="space-y-6">
      <Header />
      <CompanyReadinessView />
    </div>
  );
}

function Header() {
  return (
    <div>
      <h1 className="text-[36px] font-bold leading-tight text-[#111827]">Company Readiness</h1>
      <p className="pt-1 text-base text-[#6b7280]">See which students are ready for which company&apos;s drive, based on tagged problem coverage.</p>
    </div>
  );
}
